module.exports = __webpack_public_path__ + "images/marketing/connect-screenshot2.jpg";